import React from 'react';
import c from 'classnames';
var Steps = function Steps(_ref) {
  var steps = _ref.steps,
    currentStep = _ref.currentStep;
  return /*#__PURE__*/React.createElement("div", {
    className: "Steps"
  }, steps.map(function (step, index) {
    var stepClasses = c(index === 0 && 'firstStep', index < currentStep && 'beforeCurrentStep', index === currentStep && 'currentStep', index > currentStep && 'afterCurrentStep', index === steps.length - 1 && 'lastStep');
    return /*#__PURE__*/React.createElement("div", {
      className: "step ".concat(stepClasses)
    }, /*#__PURE__*/React.createElement("div", {
      className: "line ".concat(stepClasses)
    }, /*#__PURE__*/React.createElement("div", {
      className: "top"
    }), /*#__PURE__*/React.createElement("div", {
      className: "dot"
    }), /*#__PURE__*/React.createElement("div", {
      className: "btm"
    })), /*#__PURE__*/React.createElement("div", {
      className: "label ".concat(stepClasses)
    }, /*#__PURE__*/React.createElement("div", {
      className: "text"
    }, step.label)));
  }));
};
export default Steps;